<mat-form-field class="form-field numeric" subscriptSizing="dynamic">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControl]="control" [placeholder]="placeholder" appNumericOnly> 
    <mat-icon matSuffix *ngIf="formSubmitted && control.errors">error</mat-icon>
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
</mat-form-field>